// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router/routes';
import store from './vuex/store.js'
import { flylineChart } from '@jiaminghi/data-view'
import VueFullPage from 'vue-fullpage.js';
import 'babel-polyfill'

import 'fullpage.js/vendors/scrolloverflow';
import { Select, Option, Checkbox, CheckboxGroup, Carousel, CarouselItem  } from 'element-ui';
import './assets/style/style.css'
import animate from 'animate.css'
import common from '@/common/js/common'
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/iconfont/iconfont.css";

Vue.use(animate);
Vue.use(router);
Vue.use(Select);
Vue.use(Option);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(flylineChart)
Vue.use(VueFullPage);
Vue.config.productionTip = false;
Vue.prototype.$common = common
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});
window.onresize = function () {
  rem();
}
rem();
function rem() {
  let html = document.documentElement;
  let wW = html.clientWidth;// 窗口宽度
  // if (wW < 1200) {
  //   return
  // }
  let whdef = 120 / 1920;// 表示1920的设计图,使用120PX的默认值
  let rem = wW * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  html.style.fontSize = rem + 'px';
  document.body.style.fontSize = '20px';
}


// WEBPACK FOOTER //
// ./src/main.js